import React from 'react'
import logo from "../../assets/images/Logo-izzygo.png"
import { Link } from 'react-router-dom'
import { Trans } from 'react-i18next'
import LanguageSwitcher from '../LanguageSwitcher'

const Header = () => {

    return (
        <header id="page-topbar">
            <div className="layout-width">
                <div className="row dash-nft">
                    <div className="navbar-header">
                        <div className="d-flex align-items-center">
                            <h2 className="header-h2">
                                <Trans i18nKey="header.tagline">
                                    Healthier <span>worklife</span> starts here.
                                </Trans>
                            </h2>
                        </div>
                        <div className="d-flex align-items-center">
                            <LanguageSwitcher />
                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/home" className="logo">
                                    <span>
                                        <img src={logo} alt="" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
